const paintSuperficieCalculator = (wallWidth, wallHeight, windowsQty, doorsQty) => {
  let res = (wallWidth * wallHeight) - windowsQty - (1.5 * doorsQty);

  return (Math.round(res * 100) / 100);
}

export default paintSuperficieCalculator;
